module.exports = __webpack_public_path__ + "static/media/aktivitetsanlegg.01081d80.svg";